module.exports = __webpack_public_path__ + "static/jpower-4497ea1d18df45fb90146f8bdacee6d0.jpg";